<template>
  <div
    v-loading="loading"
    class="page-pg-action"
  >
    <el-form
      class="c-form"
      :model="xmInfo"
      :inline="true"
      label-position="right"
      label-width="150px"
      label-suffix="："
    >
      <el-row class="c-form__row">
        <el-col
          class="c-form__col c-form__part-title"
          :span="24"
        >
          评估结论
        </el-col>
        <el-col
          class="c-form__col"
          :span="24"
        >
          <el-form-item
            class="c-form__item"
            label="评估情况说明"
          >
            <template v-if="!readOnly">
              <el-input
                v-show="editPgqksm"
                v-model="pgqksm"
                type="textarea"
                :rows="3"
                class="c-form__input"
                placeholder="请输入评估情况说明"
              />
              <textarea-read
                v-show="!editPgqksm"
                v-model="xmInfo.pgqksm"
                class="c-form__read u-line-20"
              />
              <k-button
                v-show="!editPgqksm"
                btn-text="编辑"
                :auth-type="true"
                type="text"
                icon="kestrel-icon ki-edit"
                @click="startEditConclusion"
              />
              <k-button
                v-show="editPgqksm"
                btn-text="保存"
                :auth-type="true"
                type="text"
                icon="kestrel-icon ki-save"
                @click="saveConclusion"
              />
              <k-button
                v-show="editPgqksm"
                btn-text="取消"
                :auth-type="false"
                type="text"
                icon="kestrel-icon ki-close"
                @click="editPgqksm = false"
              />
            </template>
            <textarea-read
              v-else
              v-model="xmInfo.pgqksm"
              class="c-form__read u-line-20"
            />
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="24"
        >
          <el-form-item
            class="c-form__item"
            label="签到信息"
          >
            <template v-if="signIns.length">
              <span class="c-form__read">
                {{ signIns[0].qdsj | date("yyyy-MM-dd HH:mm:ss") }}
                {{ signIns[0].qdrMc }}
                {{ signIns[0].qddz }}
              </span>
              <el-popover
                v-if="signIns.length > 1"
                placement="right"
                trigger="click"
              >
                <div
                  v-for="item in signIns"
                  :key="item.qdId"
                  class="jx-pg-plan__sign-in"
                >
                  <span class="c-form__read">
                    {{ item.qdsj | date("yyyy-MM-dd HH:mm:ss") }}
                    {{ item.qdrMc }}
                    {{ item.qddz }}
                  </span>
                </div>
                <el-link
                  slot="reference"
                  type="primary"
                  :underline="false"
                >
                  详情
                </el-link>
              </el-popover>
            </template>
            <span v-else>-</span>
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="评估提醒"
          >
            <el-link
              :underline="false"
              type="primary"
            >
              未完成（{{ incompleteCount }}）
            </el-link>
            <el-link
              :underline="false"
              type="primary"
            >
              已完成（{{ xmInfo.yjcsl || 0 }}）
            </el-link>
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="评估报告"
          >
            <span
              v-if="xmInfo.bgbh"
              class="u-mg-r-6 c-form__read u-text-primary"
            >{{ xmInfo.bgbh }}</span>
            <span
              v-else
              class="c-form__read"
            >-</span>
            <k-button
              v-if="xmInfo.bgbh"
              btn-text="查看评估报告"
              :auth-type="false"
              type="primary"
              plain
              icon="kestrel-icon ki-file-pdf"
              @click="openNavTab({ name: 'jxxfPgsybg', query: { xmId } })"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div class="o-part-title">
      <span class="u-mg-r-10">评估成员</span>
      <k-button
        v-if="!readOnly"
        btn-text="编辑"
        :auth-type="true"
        type="primary"
        plain
        icon="kestrel-icon ki-edit"
        @click="showDialogName = 'member'"
      />
    </div>
    <k-table
      :table-column="memberColumns"
      :data="setting.ryList"
      :pagination-show="false"
    >
      <template #zc="scope">
        <el-input
          v-if="editingMemberIndex === scope.index"
          v-model.trim="memberForm.zc"
        />
        <span v-else>{{ scope.row.zc }}</span>
      </template>
      <template #zgzsh="scope">
        <el-input
          v-if="editingMemberIndex === scope.index"
          v-model.trim="memberForm.zgzsh"
        />
        <span v-else>{{ scope.row.zgzsh }}</span>
      </template>
      <template #division="scope">
        <div
          v-if="editingMemberIndex === scope.index"
          class="jx-pg-plan__division"
        >
          <el-select
            v-model="memberForm.ryjs"
            @change="memberRoleChanged"
          >
            <el-option
              v-for="item in memberRoles"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
          <el-select
            v-if="memberForm.ryjs === 'DXFZR'"
            v-model="memberForm.pglxDm"
            placeholder="请选择负责专业"
          >
            <el-option
              v-for="item in majors"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </div>
        <span v-else>{{ memberDivision(scope.row) }}</span>
      </template>
      <el-table-column
        v-if="!readOnly"
        label="操作"
        width="120"
        align="center"
        fixed="right"
      >
        <template slot-scope="scope">
          <template v-if="editingMemberIndex === scope.$index">
            <k-button
              btn-text="保存"
              :auth-type="true"
              type="text"
              @click="saveMemberEdit"
            />
            <k-button
              btn-text="关闭"
              :auth-type="false"
              type="text"
              @click="cancelMemberEdit"
            />
          </template>
          <template v-else>
            <k-button
              btn-text="编辑"
              :auth-type="true"
              type="text"
              plain
              @click="editMember(scope.row, scope.$index)"
            />
            <k-button
              btn-text="删除"
              :auth-type="true"
              type="text"
              @click="deleteMember(scope.row, scope.$index)"
            />
          </template>
        </template>
      </el-table-column>
    </k-table>

    <div class="o-part-title">
      <span class="u-mg-r-10">建筑信息</span>
      <k-button
        v-if="!readOnly"
        btn-text="新增"
        :auth-type="true"
        type="primary"
        plain
        icon="kestrel-icon ki-plus"
        @click="openBuilding('add')"
      />
    </div>
    <k-table
      :table-column="buildingColumns"
      :data="setting.jzwList"
      :pagination-show="false"
    >
      <template #jzwmc="scope">
        <el-link
          type="primary"
          @click="openBuilding('view', scope.row, scope.$index)"
        >
          {{ scope.row.jzwmc }}
        </el-link>
      </template>
      <el-table-column
        v-if="!readOnly"
        label="操作"
        width="120"
        align="center"
        fixed="right"
      >
        <template slot-scope="scope">
          <k-button
            btn-text="编辑"
            :auth-type="true"
            type="text"
            plain
            @click="openBuilding('edit', scope.row, scope.$index)"
          />
          <k-button
            btn-text="删除"
            :auth-type="true"
            type="text"
            @click="deleteBuilding(scope.row, scope.$index)"
          />
        </template>
      </el-table-column>
    </k-table>

    <div class="o-part-title">
      <span class="u-mg-r-10">评估仪器</span>
      <k-button
        v-if="!readOnly"
        btn-text="编辑"
        :auth-type="true"
        type="primary"
        plain
        icon="kestrel-icon ki-edit"
        @click="showDialogName = 'instrument'"
      />
    </div>
    <k-table
      :table-column="instrumentColumns"
      :data="setting.yqList"
      :pagination-show="false"
    />

    <member-dialog
      v-if="showDialogName === 'member'"
      :members="setting.ryList"
      @close="closeDialog"
      @save="saveMembers"
    />
    <building-dialog
      v-if="showDialogName === 'building'"
      :type="buildingDialogType"
      :value="buildingForm"
      :order="setting.jzwList.length + 1"
      @close="closeDialog"
      @save="saveBuilding"
    />
    <instrument-dialog
      v-if="showDialogName === 'instrument'"
      :options="instrumentOptions"
      :selected="setting.yqList"
      @close="closeDialog"
      @save="saveInstruments"
    />
  </div>
</template>

<script>
import { pgxmManageService } from '../pgxm.service';
import MemberDialog from './MemberDialog.vue';
import BuildingDialog from './BuildingDialog.vue';
import InstrumentDialog from './InstrumentDialog.vue';

export default {
  name: 'JxxfPgPlanInfo',
  components: {
    MemberDialog,
    BuildingDialog,
    InstrumentDialog
  },
  props: {
    type: {
      type: String,
      default: 'view'
    },
    xmInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      loading: false,
      signIns: [],
      instrumentOptions: [],
      editPgqksm: false,
      pgqksm: '',
      showDialogName: '',
      buildingDialogType: 'add',
      buildingIndex: -1,
      buildingForm: {},
      editingMemberIndex: -1,
      memberForm: {},
      setting: {
        lockVersion: null,
        jzwList: [],
        ryList: [],
        yqList: []
      },
      memberRoles: [
        { value: 'DXFZR', label: '评估单项负责人' },
        { value: 'PGCY', label: '评估成员' }
      ],
      majors: [
        { value: 'JZFH', label: '建筑防火' },
        { value: 'XFSS', label: '消防设施' },
        { value: 'XFAQGL', label: '消防安全管理' }
      ],
      memberColumns: [
        { key: 'index', label: '序号', align: 'center', width: 60, type: 'index' },
        { key: 'ryMc', label: '姓名', align: 'left', width: '120', type: 'text' },
        { key: 'zc', slotName: 'zc', label: '职务/职称', align: 'left', minWidth: '120', type: 'text' },
        { key: 'zgzsh', slotName: 'zgzsh', label: '执业资格证书编号', align: 'left', minWidth: '180', type: 'text' },
        { key: 'division', slotName: 'division', label: '评估分工', align: 'left', minWidth: '280', type: 'text' }
      ],
      buildingColumns: [
        { key: 'index', label: '序号', align: 'center', width: 60, type: 'index' },
        { key: 'jzwmc', slotName: 'jzwmc', label: '建筑名称', align: 'left', minWidth: '120', type: 'text' },
        { key: 'zdmj', label: '占地面积（m²）', align: 'left', minWidth: '120', type: 'text' },
        { key: 'jzmj', label: '建筑面积（m²）', align: 'left', minWidth: '120', type: 'text' },
        { key: 'zlcs', label: '楼层数', align: 'center', minWidth: '80', type: 'text' },
        { key: 'jzgd', label: '建筑高度（m）', align: 'center', minWidth: '100', type: 'text' }
      ],
      instrumentColumns: [
        { key: 'index', label: '序号', align: 'center', width: 60, type: 'index' },
        { key: 'yqmc', label: '设备名称', align: 'left', minWidth: '120', type: 'text' },
        { key: 'yqbh', label: '设备编号', align: 'left', minWidth: '120', type: 'text' },
        { key: 'jdzsbh', label: '检定/校准证书编号', align: 'left', minWidth: '160', type: 'text' },
        { key: 'jdyxqZ', label: '有效期', align: 'left', minWidth: '100', type: 'date' }
      ]
    };
  },
  computed: {
    readOnly () {
      return this.type === 'view';
    },
    xmId () {
      return this.$route.params.id;
    },
    incompleteCount () {
      return Math.max((this.xmInfo.nrrs || 0) - (this.xmInfo.yjcsl || 0), 0);
    }
  },
  methods: {
    load () {
      this.loading = true;
      return Promise.all([
        pgxmManageService.setting(this.xmId),
        pgxmManageService.instruments(),
        pgxmManageService.signIns(this.xmId)
      ]).then(([settingResponse, instrumentResponse, signInResponse]) => {
        const loaded = settingResponse.data || {};
        this.setting = {
          lockVersion: loaded.lockVersion,
          jzwList: loaded.jzwList || [],
          ryList: (loaded.ryList || []).filter(item => ['DXFZR', 'PGCY'].includes(item.ryjs)),
          yqList: loaded.yqList || []
        };
        this.instrumentOptions = instrumentResponse.data || [];
        this.signIns = signInResponse.data || [];
      }).catch(error => {
        const message = error && error.response && error.response.data && error.response.data.message;
        this.$message.error(message || '项目设定数据加载失败，请稍后重试');
      }).finally(() => {
        this.loading = false;
      });
    },
    startEditConclusion () {
      this.pgqksm = this.xmInfo.pgqksm || '';
      this.editPgqksm = true;
    },
    saveConclusion () {
      if (this.pgqksm.length > 1000) {
        this.$message.warning('【评估情况说明】长度不能超过1000位');
        return;
      }
      this.loading = true;
      pgxmManageService.getDetail(this.xmId)
        .then(response => pgxmManageService.update(this.xmId, {
          ...response.data,
          pgqksm: this.pgqksm
        }))
        .then(() => {
          this.xmInfo.pgqksm = this.pgqksm;
          this.editPgqksm = false;
          this.$message.success('修改成功！');
          this.$emit('saved');
        })
        .finally(() => {
          this.loading = false;
        });
    },
    saveSettingPart (field, list, successMessage) {
      this.loading = true;
      return pgxmManageService.saveSetting(this.xmId, {
        lockVersion: this.setting.lockVersion,
        [field]: list.map((item, index) => ({ ...item, dyxh: index + 1 }))
      }).then(() => {
        this.$message.success(successMessage);
        this.closeDialog();
        this.cancelMemberEdit();
        this.$emit('saved');
        return this.load();
      }).finally(() => {
        this.loading = false;
      });
    },
    saveMembers (members) {
      return this.saveSettingPart('ryList', members, '评估成员保存成功！');
    },
    editMember (row, index) {
      this.editingMemberIndex = index;
      this.memberForm = { ...row };
    },
    memberRoleChanged () {
      if (this.memberForm.ryjs !== 'DXFZR') this.memberForm.pglxDm = '';
    },
    saveMemberEdit () {
      if (!this.memberForm.ryjs ||
        (this.memberForm.ryjs === 'DXFZR' && !this.memberForm.pglxDm)) {
        this.$message.warning('请补全评估成员职责');
        return;
      }
      const members = this.setting.ryList.map((item, index) =>
        index === this.editingMemberIndex ? { ...this.memberForm } : item);
      this.saveSettingPart('ryList', members, '评估成员修改成功！');
    },
    cancelMemberEdit () {
      this.editingMemberIndex = -1;
      this.memberForm = {};
    },
    deleteMember (row, index) {
      this.$confirm('是否确认删除此评估成员？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const members = this.setting.ryList.filter((item, itemIndex) => itemIndex !== index);
        return this.saveSettingPart('ryList', members, '评估成员删除成功！');
      }).catch(() => {});
    },
    memberDivision (member) {
      const role = this.memberRoles.find(item => item.value === member.ryjs);
      if (member.ryjs !== 'DXFZR') return role ? role.label : '-';
      const major = this.majors.find(item => item.value === member.pglxDm);
      return `${role ? role.label : ''}${major ? `（${major.label}）` : ''}`;
    },
    openBuilding (type, row = {}, index = -1) {
      this.buildingDialogType = type;
      this.buildingForm = { ...row };
      this.buildingIndex = index;
      this.showDialogName = 'building';
    },
    saveBuilding (building) {
      const buildings = this.setting.jzwList.slice();
      if (this.buildingIndex < 0) buildings.push(building);
      else buildings.splice(this.buildingIndex, 1, building);
      return this.saveSettingPart('jzwList', buildings, '建筑信息保存成功！');
    },
    deleteBuilding (row, index) {
      this.$confirm('是否确认删除此条建筑信息记录？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const buildings = this.setting.jzwList.filter((item, itemIndex) => itemIndex !== index);
        return this.saveSettingPart('jzwList', buildings, '建筑信息删除成功！');
      }).catch(() => {});
    },
    saveInstruments (instruments) {
      return this.saveSettingPart('yqList', instruments, '评估仪器保存成功！');
    },
    closeDialog () {
      this.showDialogName = '';
      this.buildingIndex = -1;
      this.buildingForm = {};
    }
  },
  created () {
    this.load();
  }
};
</script>

<style scoped lang="scss">
.o-part-title {
  margin-top: 22px;
}

.jx-pg-plan__sign-in + .jx-pg-plan__sign-in {
  margin-top: 4px;
}

.jx-pg-plan__division {
  display: flex;
  gap: 8px;
}

.jx-pg-plan__division .el-select {
  width: 50%;
}
</style>
